
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {
  }
})
export default class extends Vue {
  get brandName() {
    const { company } = this.$route.query;
    const currentCompany = Array.isArray(company) ? company[0] || '' : company || '';
    return currentCompany.toUpperCase() === 'GEA' ? 'GEA' : 'GET';
  }
  public selectReasonList = [
    {
        id: 1,
        title: '全球版面 · 安心無憂',
        desc1: 'Prestige 在全球主要留學目的地',
        desc2: '均設有學生公寓，',
        desc3: '統一品牌管理，確保你無論身處何地，',
        desc4: '都能享受到同樣的高標準服務。'
    },
    {
        id: 2,
        title: '黃金地段 · 出行便利',
        desc1: '公寓選址優越，靠近市中心或學校，',
        desc2: '步行即可到達地鐵、巴士站與生活設施，',
        desc3: '讓學習與生活更有效率。',
        desc4: ''
    },
    {
        id: 3,
        title: '拎包入住 · 設施齊全',
        desc1: '房間配備全套家具與家電，公共設施完善，',
        desc2: 'WiFi、洗衣機、廚房一應俱全，',
        desc3: '讓你輕鬆入住，無後顧之憂。',
        desc4: ''
    },
    {
        id: 4,
        title: '專業管理 · 安全保障',
        desc1: '24小時保全與智慧門禁系統，',
        desc2: '專業管理團隊隨時待命，確保居住安全，',
        desc3: '並為你的日常需求提供協助。',
        desc4: ''
    },
    {
        id: 5,
        title: '友善社區 · 融洽氛圍',
        desc1: '留學生打造友善多元的國際社區，',
        desc2: '既能互相支持，也能拓展跨文化人脈。',
        desc3: '',
        desc4: ''
    },
    {
        id: 6,
        title: '溫暖關懷 · 活動豐富',
        desc1: 'Prestige 不只是住宿，',
        desc2: '更是你在海外的「第二個家」。',
        desc3: '我們定期舉辦節慶慶祝與社交活動，',
        desc4: '讓你在異國他鄉也能感受到歸屬感。'
        }
 ];
}
